















































import { Component, Vue } from "vue-property-decorator";
import { user } from "./board";
import { Action, State, Mutation } from "vuex-class";

@Component
export default class App extends Vue {
  @State("myUser") storeMyUser: user;
  @Action updateUserInfo;

  get myUser() {
    return this.storeMyUser;
  }

  public mounted() {
    let newUserData = this.$cookies.get("planningJwt");
    if (!newUserData) {
      try {
        const currentUser = localStorage.getItem("planningUser");
        newUserData = JSON.parse(currentUser);
      } catch (error) {
        console.log(error);
        localStorage.removeItem("planningUser");
      }
    }
    if (newUserData) {
      const newUser = {
        name: newUserData.name,
        email: newUserData.email,
        picture: newUserData.picture,
        token: newUserData.token
      };
      this.updateUserInfo(newUser);
    }
  }
}
